import Resource from '@/plugins/sdk/Resource'
import { STRING, UUID } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'dictionary_itemtype'

  static get fields () {
    return {
      id: new UUID(),
      reference: new STRING(),
      desc: new STRING(),
      edi: new STRING(),
      edi_short: new STRING()
    }
  }
}
